export const STRIP_PRIORITY_GRID_TYPE = {
  TRAILERS: "trailers",
  SHIPMENTS: "shipments",
};

export const STRIP_PRIORITY_TRAILER_KEY_SEPARATOR = "|";

export const STRIP_SHIPMENTS_PRINT_TITLE = "Strip Shipments";